<template>
    <div class="relative border-b border-black h-8 lg:h-12 w-full font-freizeit">
        <button
            type="button"
            aria-haspopup="listbox"
            @click="toggleMenu"
            class="h-full w-full flex flex-row justify-between text-2xl sm:text-3xl"
        >
            <span>
                {{ selectedOption }}
            </span>

            <img
                src="../assets/icons/chevron.svg"
                alt=""
                width="12"
                height="12"
                :class="{ '-rotate-180': isOpen }"
                class="mt-3 lg:mt-6 transition-transform duration-200 ease-in-out"
            >
        </button>

        <base-scroll-container
            role="listbox"
            :aria-labelledby="groupData.name"
            :class="{ 'pointer-events-none opacity-0 transform origin-bottom md:origin-top scale-y-75': !isOpen }"
            class="absolute z-10 bottom-0 md:bottom-auto lg:top-12 max-h-56 w-full transition-all duration-150 ease-in-out"
        >
            <div class="border-2 border-black w-full h-full bg-cloud-dark text-base">
                <div
                    v-for="(option, index) in filteredOptions"
                    :key="option"
                    role="option"
                    tabindex="0"
                    @click="setSelectedOption(option.code)"
                    @keyup.enter="setSelectedOption(option.code)"
                    :class="{ 'border-b-2 border-black': index + 1 !== filteredOptions.length }"
                    class="cursor-pointer px-3 md:px-7 py-1 md:py-2 hover:bg-background transition-all duration-300 ease-in-out"
                >
                    {{ option.description[0].name }}
                </div>
            </div>
        </base-scroll-container>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import BaseScrollContainer from './BaseScrollContainer.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseScrollContainer,
        },

        data() {
            return {
                isOpen: false,
            };
        },

        props: {
            groupData: {
                type: Object,
                required: true,
            },
        },

        computed: {
            controllerState() {
                return this.customizerStore.viewController?.state;
            },

            selectedOption() {
                const groupIndex = this.controllerState.map((x) => x.placement.name).indexOf(this.groupData.name);

                return this.controllerState[groupIndex].component.description[0].name;
            },

            filteredOptions() {
                return this.groupData.placements[0].components.filter((component) => !component.placeholder);
            },
        },

        mounted() {
            window.addEventListener('click', (e) => {
                this.closeMenuOnOutsideClick(e);
            });
        },

        beforeUnmount() {
            window.removeEventListener('click', (e) => {
                this.closeMenuOnOutsideClick(e);
            });
        },

        methods: {
            toggleMenu() {
                this.isOpen = !this.isOpen;
            },

            setSelectedOption(option) {
                this.toggleMenu();

                this.customizerStore.viewController.updateComponent(this.groupData.name, option);
                this.customizerStore.setBottleLabelText();
            },

            closeMenuOnOutsideClick(e) {
                if (!this.$el.contains(e.target)) {
                    this.isOpen = false;
                }
            },
        },
    };
</script>
